export const route = 'getDetailedForecastData';

export const layoutConfig = {
  '1x1': {
    visibleCount: ({ compact1x1VisibleCount }) => compact1x1VisibleCount,
    selectorMode: 'row',
    selectorHeight: 'clamp(4.25rem, 46%, 4.75rem)',
    selectorGap: 6,
    selectorTileStyle: { padding: '0.25rem 0.35rem' },
    wrapperClassName: 'd-flex flex-column w-100 h-100 overflow-hidden',
    contentClassName: 'd-flex flex-column w-100 h-100 p-1',
    detailsClassName: 'pt-1 px-1',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 1),
    }),
    detailsIconSize: 14,
    detailGroups: [
      ['temperature', 'comfort'],
      ['dewPoint', 'humidity'],
      ['windSpeed', 'windDirection'],
      ['visibility', 'precipitationProbability'],
    ],
  },
  '1x2': {
    visibleCount: ({ compact1x2ColumnCount }) => compact1x2ColumnCount * 2,
    selectorMode: 'grid',
    selectorHeight: 'clamp(8.5rem, 50%, 13rem)',
    selectorGap: 6,
    selectorListStyle: {
      gridTemplateRows: 'repeat(2, minmax(0, 1fr))',
    },
    selectorTileStyle: { padding: '0.45rem' },
    wrapperClassName: 'd-flex flex-column w-100 h-100 overflow-hidden',
    contentClassName: 'd-flex flex-column w-100 h-100 p-2',
    detailsClassName: 'pt-2 px-1',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 1),
    }),
    detailsIconSize: 16,
    detailGroups: [
      [
        'temperature',
        'comfort',
        'dewPoint',
        'humidity',
        'windSpeed',
        'windDirection',
        'visibility',
        'precipitationProbability',
      ],
    ],
  },
  '2x1': {
    visibleCount: () => 7,
    selectorMode: 'row',
    selectorHeight: 'clamp(4.75rem, 48%, 6.75rem)',
    selectorGap: 8,
    selectorListStyle: { justifyContent: 'center' },
    selectorTileStyle: {
      flex: '0 0 calc((100% - 48px) / 7)',
      padding: '0.45rem',
    },
    wrapperClassName: 'd-flex flex-column w-100 h-100 overflow-hidden',
    contentClassName: 'd-flex flex-column w-100 h-100 px-2 pb-2',
    detailsClassName: 'pt-2 px-2',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 1),
    }),
    detailsIconSize: 16,
    detailGroups: [
      ['temperature', 'comfort', 'dewPoint', 'humidity'],
      ['windSpeed', 'windDirection', 'visibility', 'precipitationProbability'],
    ],
  },
};
